import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSliderComponent } from './data-slider.component';
import { DataSliderItemComponent } from './data-slider-item.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ButtonModule } from '../button/button.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    ButtonModule
  ],
  declarations: [
    DataSliderComponent,
    DataSliderItemComponent,
  ],
  exports: [
    DataSliderComponent,
    DataSliderItemComponent,
  ]
})
export class DataSliderModule {}
